import { useLogger } from "@amzn/xb-hooks";
import intersection from "lodash/intersection";

export const usePropMerge = (
  { allowedCollisions = [] }: { allowedCollisions: string[] },
  ...toMerge: Array<Record<string, any>>
) => {
  const log = useLogger();

  const validAllowedCollision = toMerge
    .map((obj) => Object.keys(obj))
    .flatMap((keys) => intersection(allowedCollisions, keys));

  if (allowedCollisions.length > 0 && validAllowedCollision.length === 0) {
    allowedCollisions.forEach((key) => log.warn(`Useless allowed collision: ${key}`));
  }

  if (toMerge.length === 0) {
    return {};
  }

  return toMerge.reduce((memo: Record<string, any>, obj: Record<string, any>) => {
    const collisions = intersection(Object.keys(memo), Object.keys(obj));

    collisions
      .filter((key) => allowedCollisions.includes(key))
      .forEach((key) => log.info(`Overriding key ${key} without issue.`));

    collisions
      .filter((key) => !allowedCollisions.includes(key))
      .forEach((key) => log.error(`Dangerously overriding key: ${key}.`));
    return {
      ...memo,
      ...obj,
    };
  });
};
